// Detect flash parameter in the URL and remove it without refreshing the page
// Used to display flash messages without them coming from the backend
export function flashMessageRedirect() {
    const FLASH_PARAM_NAME = 'flash';
    const url = new URL(window.location.href);
    if (url.searchParams.has(FLASH_PARAM_NAME)) {
        url.searchParams.delete(FLASH_PARAM_NAME);
        history.replaceState(history.state, '', url.toString());
    }
}
